import { atomWithStorage } from "jotai/utils";
import type { IProductWithCmsDataAndQualification } from "../../features/products/type/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";

export const SUBSCRIPTION_CART_STORAGE_INDEX = "bx-subscription-cart";

export const SubscriptionCartStore = atomWithStorage<IProductWithCmsDataAndQualification | undefined>(
  SUBSCRIPTION_CART_STORAGE_INDEX,
  undefined
);
